/**
 * Landing Feature - Repository Implementation
 */

import type { ILandingRepository } from "../../domain/repositories";
import type {
  ContactFormData,
  MailingListSubscription,
  ApiResult,
} from "../../domain/entities";
import { landingApi } from "../services";
import { contactFormMapper, mailingListMapper } from "../mappers";

/**
 * Landing repository implementation
 */
export const landingRepository: ILandingRepository = {
  /**
   * Submit contact form
   */
  async submitContactForm(data: ContactFormData): Promise<ApiResult> {
    const dto = contactFormMapper.toDTO(data);
    const success = await landingApi.submitContactForm(dto);
    return {
      success,
      message: success ? "landing.contact.success" : "landing.contact.error",
    };
  },

  /**
   * Subscribe to mailing list
   */
  async subscribeToMailingList(
    data: MailingListSubscription
  ): Promise<ApiResult> {
    const dto = mailingListMapper.toDTO(data);
    const success = await landingApi.subscribeToMailingList(dto);
    return {
      success,
      message: success
        ? "landing.subscribe.success"
        : "landing.subscribe.error",
    };
  },
};

export default landingRepository;
